<template>
    <div
        class="qr-scanner"
        ref="container"
        onresize="updateRegionSize"
    >
        <video
            id="scanner-vid"
            ref="video"
            class="qr-scanner__video"
            :style="{height: videoSize }"
        />
        <div
            class="qr-scanner__overlay"
            :class="{ paused: paused }"
        >
            <div
                class="qr-scanner__region"
                v-show="hasCamera"
                :style="{height: regionSize, width: regionSize}"
            />
            <div
                class="qr-scanner__tip"
                v-show="!hasCamera"
            >
                You must <strong>allow</strong> the camera permission in your browser for the QR scanner to work
            </div>
            <button
                class="qr-scanner__swap-btn"
                @click.prevent="swapCamera"
            >
                <i class="fa fa-redo-alt" />
            </button>
            <button
                class="qr-scanner__flash-btn"
                v-show="hasFlash"
                @click.prevent="toggleFlash"
            >
                <i
                    v-show="!isFlashOn"
                    class="far fa-lightbulb"
                />
                <i
                    v-show="isFlashOn"
                    class="fas fa-lightbulb"
                />
            </button>
            <button
                class="qr-scanner__btn"
                v-show="paused"
                @click.prevent="startScanning"
            >
                <i class="fa fa-camera" />
            </button>
        </div>
    </div>
</template>

<script>
import QrScanner from 'qr-scanner';
export default {

    props: {
        value: {
            required: false,
            default: null,
        }
    },
    data () {
        return {
            scanner: undefined,
            paused: false,
            videoSize: 0,
            regionSize: 0,
            cameraFacing: undefined,
            hasCamera: undefined,
            hasFlash: false,
            isFlashOn: false,
        };
    },

    mounted () {
        this.updateRegionSize();
        this.initScanner();
        
    },

    beforeDestroy () {
        this.scanner.destroy();
    },

    methods: {
        initScanner () {
            QrScanner.hasCamera().then(val => {
                this.hasCamera = val;
            });
            if (typeof this.scanner !== 'undefined') {
                this.scanner.destroy();
                this.scanner = undefined;
            }
            window.setTimeout(() => {
                this.scanner = new QrScanner(this.$refs.video, this.onScan, undefined, undefined, this.cameraFacing);
                this.scanner.start();
                this.hasFlash = false;
                this.scanner.hasFlash().then(val => {
                    this.hasFlash = true;
                });
                this.checkFlash();
            }, 1000);
        },
        onScan (value) {
            if (!this.paused) {
                this.$emit('input', value);
            }
            this.paused = true;
        },
        onScanError (error) {
            console.warning('QR Error:' + error);
        },
        toggleFlash () {
            this.scanner.toggleFlash();
            this.checkFlash();
        },
        checkFlash () {
            this.isFlashOn = false;
            if (typeof this.scanner === 'undefined') {
                return;
            }
            this.isFlashOn = this.scanner.isFlashOn();
        },
        updateRegionSize () {
            this.regionSize = 0;
            this.videoSize = 0;
            if (!this.$refs.container) {
                return;
            }
            this.regionSize = (this.$refs.container.clientWidth / 4) + 'px';
            this.videoSize = (this.$refs.video.clientWidth) + 'px';
        },
        startScanning () {
            this.paused = false;
            this.scanner.start();
        },
        swapCamera () {
            this.cameraFacing = this.cameraFacing === undefined ? 'user' : undefined;
            this.initScanner();
        },
    }

}
</script>
<style scoped lang="scss">
.qr-scanner {
    margin: 0 auto;
    text-align: center;
    max-width: 500px;
    width: 100%;
    position: relative;
    background: black;
    z-index: 9000;


    &__video {
        width: 100%;
        height: 100%;
    }

    &__overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;

        &.paused {
            background: rgba(white, .6);
            backdrop-filter: blur(10px);

            .qr-scanner__region {
                display: none;
            }
        }
    }

    &__region {
        max-width: 400px;
        max-height: 400px;
        width: 33.3%;
        border: 2px solid red;
        opacity: .8;
        border-radius: 3px;
    }

    &__swap-btn, &__flash-btn {
        position: absolute;
        top: 0;
        right: 0;
        padding: 2px 5px;
        color: white;
        background: transparent;
        appearance: none;
        font-size: 2rem;
        outline: none;
        border: none;
    }
    &__flash-btn {
        position: absolute;
        top: 0;
        right: 30px;
        padding: 2px 5px;
        color: white;
        background: transparent;
        appearance: none;
        font-size: 2rem;
        outline: none;
        border: none;
    }

    &__btn {
        position: absolute;
        font-size: 3rem;
        appearance: none;
        background: transparent;
        border: none;
        color: white;
    }
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/QRScannerComponent.vue